import { useChatStore } from '@/store/chatStore';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import ChatComponent from './components/ChatComponent';
import ChatWrapper from './components/ChatWrapper';
import { useConfigStore } from './store/configStore';
import { ChatWidgetConfig } from './types';

interface AppProps {
  appConfig?: ChatWidgetConfig;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App({ appConfig }: AppProps) {
  const { setWebhookUrl } = useChatStore();
  const { setConfig, config } = useConfigStore();

  useEffect(() => {
    setWebhookUrl(appConfig?.webhookUrl || '');

    if (appConfig) {
      setConfig(appConfig);
    }
  }, [appConfig, setWebhookUrl, setConfig]);

  const cssVariables = useMemo(() => {
    return {
      '--accent-25': config?.colors?.accent?.[25],
      '--accent-100': config?.colors?.accent?.[100],
      '--accent-200': config?.colors?.accent?.[200],
      '--accent-300': config?.colors?.accent?.[300],
      '--accent-400': config?.colors?.accent?.[400],
      '--accent-500': config?.colors?.accent?.[500],
      '--accent-600': config?.colors?.accent?.[600],
      '--accent-700': config?.colors?.accent?.[700],
      '--accent-800': config?.colors?.accent?.[800],
      '--accent-900': config?.colors?.accent?.[900],
    };
  }, [config]);

  return (
    <QueryClientProvider client={queryClient}>
      <ChatWrapper cssVariables={cssVariables as Record<string, string>}>
        <ChatComponent />
      </ChatWrapper>
    </QueryClientProvider>
  );
}

export default App;
